import React from 'react';
import { SlideNav } from '../components/deck/SlideNav';
import { DeckSlides } from '../components/deck/DeckSlides';

/**
 * Deck page: investor deck (full deck with traction, team, market, investment).
 * Deck images: put files in public/deck/images/ (e.g. from slides/public/images).
 */
export default function Deck() {
  return (
    <div className="min-h-screen bg-white">
      <SlideNav />
      <main className="deck-export relative">
        <DeckSlides />
      </main>
    </div>
  );
}
